/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Sentry úroveň chyby.
 *
 * Zdroje:
 * - [TypeScript rozhraní](https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/severity.ts)
 * - [Dokumentace](https://docs.sentry.io/platforms/javascript/#level)
 * @enum {string}
 */
const SentrySeverity = {
  Critical: 'critical',
  Debug: 'debug',
  Error: 'error',
  Fatal: 'fatal',
  Info: 'info',
  Log: 'log',
  Warning: 'warning'
};

export default SentrySeverity;
